export const emeaCountries = [
  // ───────────── EUROPE ─────────────
  'ALB', // Albania
  'AND', // Andorra
  'AUT', // Austria
  'BLR', // Belarus
  'BEL', // Belgium
  'BIH', // Bosnia and Herzegovina
  'BGR', // Bulgaria
  'HRV', // Croatia
  'CYP', // Cyprus
  'CZE', // Czechia
  'DNK', // Denmark
  'EST', // Estonia
  'FRO', // Faroe Islands
  'FIN', // Finland
  'FRA', // France
  'DEU', // Germany
  'GIB', // Gibraltar
  'GRC', // Greece
  'GGY', // Guernsey
  'HUN', // Hungary
  'ISL', // Iceland
  'IRL', // Ireland
  'IMN', // Isle of Man
  'ITA', // Italy
  'JEY', // Jersey
  'XKX', // Kosovo (user-assigned)
  'LVA', // Latvia
  'LIE', // Liechtenstein
  'LTU', // Lithuania
  'LUX', // Luxembourg
  'MLT', // Malta
  'MDA', // Moldova
  'MCO', // Monaco
  'MNE', // Montenegro
  'NLD', // Netherlands
  'MKD', // North Macedonia
  'NOR', // Norway
  'POL', // Poland
  'PRT', // Portugal
  'ROU', // Romania
  'RUS', // Russia
  'SMR', // San Marino
  'SRB', // Serbia
  'SVK', // Slovakia
  'SVN', // Slovenia
  'ESP', // Spain
  'SWE', // Sweden
  'CHE', // Switzerland
  'UKR', // Ukraine
  'GBR', // United Kingdom
  'VAT', // Vatican City

  // ───────────── MIDDLE EAST ─────────────
  'BHR', // Bahrain
  'IRN', // Iran
  'IRQ', // Iraq
  'ISR', // Israel
  'JOR', // Jordan
  'KWT', // Kuwait
  'LBN', // Lebanon
  'OMN', // Oman
  'PSE', // Palestine
  'QAT', // Qatar
  'SAU', // Saudi Arabia
  'SYR', // Syria
  'TUR', // Türkiye
  'ARE', // United Arab Emirates
  'YEM', // Yemen

  // ───────────── AFRICA ─────────────
  'DZA', // Algeria
  'AGO', // Angola
  'BEN', // Benin
  'BWA', // Botswana
  'BFA', // Burkina Faso
  'BDI', // Burundi
  'CPV', // Cabo Verde
  'CMR', // Cameroon
  'CAF', // Central African Republic
  'TCD', // Chad
  'COM', // Comoros
  'COG', // Congo (Republic)
  'COD', // Congo (Democratic Republic)
  'CIV', // Côte d'Ivoire
  'DJI', // Djibouti
  'EGY', // Egypt
  'GNQ', // Equatorial Guinea
  'ERI', // Eritrea
  'SWZ', // Eswatini
  'ETH', // Ethiopia
  'GAB', // Gabon
  'GMB', // Gambia
  'GHA', // Ghana
  'GIN', // Guinea
  'GNB', // Guinea-Bissau
  'KEN', // Kenya
  'LSO', // Lesotho
  'LBR', // Liberia
  'LBY', // Libya
  'MDG', // Madagascar
  'MWI', // Malawi
  'MLI', // Mali
  'MRT', // Mauritania
  'MUS', // Mauritius
  'MAR', // Morocco
  'MOZ', // Mozambique
  'NAM', // Namibia
  'NER', // Niger
  'NGA', // Nigeria
  'RWA', // Rwanda
  'STP', // São Tomé and Príncipe
  'SEN', // Senegal
  'SYC', // Seychelles
  'SLE', // Sierra Leone
  'SOM', // Somalia
  'ZAF', // South Africa
  'SSD', // South Sudan
  'SDN', // Sudan
  'TZA', // Tanzania
  'TGO', // Togo
  'TUN', // Tunisia
  'UGA', // Uganda
  'ZMB', // Zambia
  'ZWE' // Zimbabwe
]

export const lacarCountries = [
  // ───────────── NORTH & CENTRAL AMERICA ─────────────
  'MEX', // Mexico
  'BLZ', // Belize
  'CRI', // Costa Rica
  'SLV', // El Salvador
  'GTM', // Guatemala
  'HND', // Honduras
  'NIC', // Nicaragua
  'PAN', // Panama

  // ───────────── SOUTH AMERICA ─────────────
  'ARG', // Argentina
  'BOL', // Bolivia
  'BRA', // Brazil
  'CHL', // Chile
  'COL', // Colombia
  'ECU', // Ecuador
  'GUY', // Guyana
  'PRY', // Paraguay
  'PER', // Peru
  'SUR', // Suriname
  'URY', // Uruguay
  'VEN', // Venezuela

  // ───────────── CARIBBEAN ─────────────
  'AIA', // Anguilla
  'ATG', // Antigua and Barbuda
  'ABW', // Aruba
  'BHS', // Bahamas
  'BRB', // Barbados
  'BES', // Bonaire, Sint Eustatius and Saba
  'VGB', // British Virgin Islands
  'CYM', // Cayman Islands
  'CUB', // Cuba
  'CUW', // Curaçao
  'DMA', // Dominica
  'DOM', // Dominican Republic
  'GRD', // Grenada
  'GLP', // Guadeloupe
  'HTI', // Haiti
  'JAM', // Jamaica
  'MTQ', // Martinique
  'MSR', // Montserrat
  'PRI', // Puerto Rico
  'BLM', // Saint Barthélemy
  'KNA', // Saint Kitts and Nevis
  'LCA', // Saint Lucia
  'MAF', // Saint Martin (French)
  'VCT', // Saint Vincent and the Grenadines
  'SXM', // Sint Maarten (Dutch)
  'TTO', // Trinidad and Tobago
  'TCA', // Turks and Caicos Islands
  'VIR', // U.S. Virgin Islands

  // ───────────── OTHER (often included in LATAM) ─────────────
  'GUF' // French Guiana
]
